export default {
  etapesPro: [
    {
      nom: "votre-identite",
      libelle: "Votre entreprise",
    },
    {
      nom: "vos-besoins",
      libelle: "Vos besoins",
    },
    {
      nom: "vos-compteurs",
      libelle: "Vos compteurs",
    },
    {
      nom: "vos-informations",
      libelle: "Vos coordonnées",
    },
  ],
  etapesParticulier: [
    {
      nom: "votre-identite",
      libelle: "Votre identité"
    },
  ],
}
